import SectionTitle from "@/components/SectionTitle";

/* Tile data (order/content from your screenshot) */
const TILES = [
  { title: "JavaScript", desc: "React, Node.js, and more", badge: "JS" },
  { title: "Python", desc: "Data Analysis, Scripting, Automation", badge: "Py" },
  { title: "IoT", desc: "Embedded Systems, Sensors, Raspberry Pi", badge: "IoT" },
  { title: "Robotics", desc: "Arduino, ESP, Automation", badge: "🤖" },
  { title: "Web Development", desc: "React, HTML, CSS, Vue, Responsive Design, APIs", badge: "HTML" },
  { title: "Linux & Networking", desc: "Linux CLI, Shell Scripting, SSH, Networking Basics, System Admin", badge: "🐧" },
];

function Badge({ label }) {
  return (
    <span className="grid h-12 w-12 place-items-center rounded-lg bg-[color-mix(in_oklab,#fff_10%,transparent)] dark:bg-[color-mix(in_oklab,#000_28%,transparent)] text-[#f97316] border border-white/10">
      <span className="text-sm font-bold leading-none">{label}</span>
    </span>
  );
}

export default function Skills() {
  return (
    <section id="skills" className="relative py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <SectionTitle
          eyebrow="Skills"
          title="Tools of the trade"
          center
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {TILES.map((t) => (
            <article
              key={t.title}
              className="
                group relative rounded-2xl p-6 text-center
                border border-white/12
                bg-[color-mix(in_oklab,#fff_10%,transparent)]
                dark:bg-[color-mix(in_oklab,#000_28%,transparent)]
                shadow-[0_1px_0_rgba(255,255,255,.05),0_6px_24px_rgba(0,0,0,.18)]
                hover:shadow-[0_1px_0_rgba(255,255,255,.06),0_10px_30px_rgba(0,0,0,.24)]
                transition-transform duration-200 ease-out hover:-translate-y-[2px]
              "
            >
              <div className="flex flex-col items-center gap-4">
                <Badge label={t.badge} />
                <h3 className="text-lg font-semibold tracking-tight">{t.title}</h3>
                <p className="text-sm text-[color-mix(in_oklab,currentColor_78%,transparent)] max-w-[22rem]">
                  {t.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>

      {/* Ambient blobs */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute left-[8%] bottom-[12%] h-24 w-24 rounded-full bg-[color:var(--color-accent)]/20 blur-2xl" />
        <div className="absolute right-[10%] top-[16%] h-24 w-24 rounded-full bg-[color:var(--color-primary)]/20 blur-2xl" />
      </div>
    </section>
  );
}